import React from 'react';
import LogoutHeader from '../../components/Headers/LogoutHeader';
import SendAgain from '../../components/SendAgain';
import { Container, Row, Col } from 'react-bootstrap';

const SendAgainPage = () => {
  return (
    <>  
      <LogoutHeader />
      <main className="section-spaces">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <SendAgain />
            </Col>
          </Row>
        </Container> 
      </main>
    </>
  );
}

export default SendAgainPage;